<template>
  <div id="app">
    <div class="fleft" v-if="isMqVersion == false">
      <div v-if="tile.completed">
        <div class="slds-progress-ring slds-progress-ring_complete">
          <div class="slds-progress-ring__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="100">
          <svg viewBox="-1 -1 2 2">
          <circle class="slds-progress-ring__path" id="slds-progress-ring-path-50" cx="0" cy="0" r="1"></circle>
          </svg>
          </div>
          <div class="slds-progress-ring__content">
          <span class="slds-icon_container slds-icon-utility-check" title="Complete">
          <svg class="slds-icon" aria-hidden="true">
          <use xlink:href="/libs/vendors/salesforce-lightning-design-system-2.6.2/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
          </svg>
          <span class="slds-assistive-text">Complete</span>
          </span>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="position: relative;padding-left: 25px;padding-top: 25px;">
          <div class="slds-spinner_container">
            <div role="status" class="slds-spinner slds-spinner_small">
              <span class="slds-assistive-text">Loading</span>
              <div class="slds-spinner__dot-a"></div>
              <div class="slds-spinner__dot-b"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fleft ftext">
      <div v-if="isMqVersion">
        <div>
          <h2 class="demoBoostTitle_mq">{{ tile.title }}</h2>
        </div>
      </div>
      <div v-else>
        <h2>{{ tile.title }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tile: {
      completed: false,
      title: "",
      description: "",
    },
    isMqVersion : true
  },
};
</script>

<style>
h2.demoBoostTitle_mq::before{
  content: "\27A4";
  font-size: 15px;
  padding-right: 5px;
}
h2.demoBoostTitle_mq{
  text-align: left;
}
  
.tooltip {
  position: relative;
  display: inline-block;
  margin-top: 0.75rem;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  margin-left: -225px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.arrow{
  padding: 4px;
}

.fleft {
  float: left;
  padding: 10px 2px 5px 8px;
}

h2 {
  font-weight: bold;
  margin-top: 0.8rem;
  margin-bottom: 5px;
}

.ftext {
  padding-top: 2px;
}

.untick {
  background: URL("https://i.imgur.com/AU9ej6y.png");
  overflow: auto;
  height: 80%;
  width: 80%;
  min-height: 30px;
  min-width: 50px;
  margin: 5%;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  opacity: 0.8;
}

.tick {
  background: URL("https://imgur.com/m1lyUj0.png");
  overflow: auto;
  height: 80%;
  width: 80%;
  min-height: 30px;
  min-width: 50px;
  border-right: 1px solid #c1c1c1;
  margin: 5%;
  background-repeat: no-repeat !important;
  background-size: contain !important;
}
.slds-progress-ring {
    position: relative;
    display: inline-block;
    height: 1.5rem;
    width: 1.5rem;
    margin: 0.2rem;
    border-radius: 1.5rem;
    background: #dddbda;
}
.slds-spinner_small, .slds-spinner--small {
    width: 1rem;
}
</style>
